import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Modal, Avatar } from "antd";

import { RxCross2 } from "react-icons/rx";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { CiGlobe } from "react-icons/ci";
import { MdOutlineEmail } from "react-icons/md";
import { FaPhone, FaLocationDot } from "react-icons/fa6";

import { UniversityAction } from "../../store/actions";

import General from "../../containers/university-details/general-data";

import Spacer from "../spacer";
import Loader from "../loader";
import tabs from "../tabs";
import modal from "../modal";

import { Images } from "../../config";

import "./styles.css";

const UniversityInfoModal = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = props?.uniId;

  const profileData = useSelector((state) => state?.profile?.user);
  const university = useSelector((state) => state?.university);
  const universityAppsShorts = useSelector(
    (state) => state?.university?.universityAppsShorts
  );

  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  useEffect(() => {
    if (props?.open) {
      dispatch(UniversityAction.getUniversityDetails(id));
      dispatch(
        UniversityAction.getUniAppsShorts({
          universityId: id,
          schoolId: profileData?.schoolId ?? profileData?.staff?.schoolId,
        })
      );
    }
  }, [props?.open]);

  const tabsArray = [
    {
      label: (
        <div className="uni-details-tabs-container">
          <div className="uni-details-tabs-image">
            <img src={Images.Unigeneral} />
          </div>
          <div>General</div>
        </div>
      ),
      key: "1",
      children: <General uniData={university?.university?.general} />,
    },
    {
      label: (
        <div className="uni-details-tabs-container">
          <div className="uni-details-tabs-image">
            <img src={Images.Uniadmission} />
          </div>
          <div>Admission</div>
        </div>
      ),
      key: "2",
      children: null,
    },
    {
      label: (
        <div className="uni-details-tabs-container">
          <div className="uni-details-tabs-image">
            <img src={Images.Uniprograms} />
          </div>
          <div>Programs</div>
        </div>
      ),
      key: "3",
      children: null,
    },
    {
      label: (
        <div className="uni-details-tabs-container">
          <div className="uni-details-tabs-image">
            <img src={Images.Unifinance} />
          </div>
          <div>Finance</div>
        </div>
      ),
      key: "4",
      children: null,
    },
    {
      label: (
        <div className="uni-details-tabs-container">
          <div className="uni-details-tabs-image">
            <img src={Images.Uniappjourney} />
          </div>
          <div>Application Journey</div>
        </div>
      ),
      key: "5",
      children: null,
    },
  ];

  const heroRightData = [
    {
      icon: <CiGlobe color="black" fontSize={"0.75em"} />,
      value: (
        <Link to={university?.university?.common?.website} target="_blank">
          <div className="text-white font-normal text-[0.875em] underline">
            {university?.university?.common?.website}
          </div>
        </Link>
      ),
    },
    {
      icon: <MdOutlineEmail color="black" fontSize={"0.75em"} />,
      value: (
        <Link to={`mailto:${university?.university?.common?.email}`}>
          <div className="text-white font-normal text-[0.875em]">
            {university?.university?.common?.email}
          </div>
        </Link>
      ),
    },
    {
      icon: <FaPhone color="black" fontSize={"0.625em"} />,
      value: (
        <div>
          {university?.university?.common?.phone?.trim()?.startsWith("+")
            ? university?.university?.common?.phone
            : `+${university?.university?.common?.phone}`}
        </div>
      ),
    },
    {
      icon: <FaLocationDot color="black" fontSize={"0.625em"} />,
      value: <div>{university?.university?.common?.address}</div>,
    },
  ];

  return (
    <Modal
      title={null}
      footer={null}
      centered={true}
      closeIcon={false}
      className="uni-info-modal"
      {...props}
    >
      <div className="text-black">
        {university?.isLoading ? (
          <div className="py-20">
            <Loader.Circular />
          </div>
        ) : (
          <>
            <div
              className="university-hero-section-modal"
              style={{
                backgroundImage: `linear-gradient(to right,rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8)), url(${
                  university?.university?.common?.campusPic ??
                  Images?.DefaultUniCover
                })`,
              }}
            >
              <RxCross2
                className="text-white text-[1.875em] absolute top-4 right-4 cursor-pointer"
                onClick={() => props?.onCancel()}
              />
              <div className="flex justify-between">
                <div className="p-3" onClick={() => setIsAboutModalOpen(true)}>
                  <div className="flex bg-white rounded-lg justify-center items-center gap-2 p-2 cursor-pointer">
                    <BsFillInfoCircleFill className="text-main" />
                    <div className="font-medium">Learn more</div>
                  </div>
                </div>
                <div className="hero-right-part">
                  <div className="flex gap-2 items-center pb-2 border-b">
                    <img
                      src={
                        university?.university?.common?.profilePic ??
                        Images.LogoIconOnly
                      }
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Images.LogoIconOnly;
                      }}
                      className="h-[2.25em] w-[2.25em] object-contain"
                    />
                    <div>Contact Us</div>
                  </div>
                  {heroRightData?.map((item, index) => (
                    <div
                      className="flex gap-2 items-center text-[0.875em]"
                      key={index}
                    >
                      <div className="bg-white rounded-full flex justify-center items-center p-1">
                        {item.icon}
                      </div>
                      {item?.value}
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex justify-between gap-2 px-5 pt-2 pb-4 bg-gradient-to-tl from-[#000000c7] from-1% to-transparent to-90% rounded-b-2xl">
                <div className="flex gap-3 text-white items-center">
                  <img
                    src={
                      university?.university?.common?.profilePic ??
                      Images.LogoIconOnly
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = Images.LogoIconOnly;
                    }}
                    className="uni-profilepic-container"
                  />
                  <div className="flex flex-col gap-2 ">
                    <div className="text-[1.375em] uppercase font-bold">
                      {university?.university?.common?.name}
                    </div>
                    <div className="flex gap-2">
                      <img src={Images.LocationPin} />
                      <div className="font-semibold">
                        {university?.university?.common?.city &&
                          `${university?.university?.common?.city}`}
                        {university?.university?.common?.state &&
                          `, ${university?.university?.common?.state}`}
                        {university?.university?.common?.country?.name &&
                          `, ${university?.university?.common?.country.name}`}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-3">
                  <div className="flex gap-2 items-center justify-center max-w-[20.75em]">
                    <div className="w-max flex items-center justify-center">
                      {universityAppsShorts?.applicationData?.images?.length >
                        0 && (
                        <Avatar.Group>
                          {universityAppsShorts?.applicationData?.images?.map(
                            (item, index) => (
                              <Avatar
                                src={item}
                                key={index}
                                className="w-[3.25em] h-[3.25em] aspect-square"
                              />
                            )
                          )}
                        </Avatar.Group>
                      )}
                    </div>
                    <div className="flex flex-col gap-2 text-white w-max ">
                      <div className="font-semibold">
                        {universityAppsShorts?.applicationData?.count} Students
                      </div>
                      <div
                        className="text-[0.825em] line-clamp-1 text-ellipsis"
                        title={university?.university?.common?.name}
                      >
                        Applied in {university?.university?.common?.name}
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2 items-center justify-center max-w-[20.75em]">
                    <div className="w-max flex items-center justify-center">
                      {universityAppsShorts?.shortlistData?.images?.length >
                        0 && (
                        <Avatar.Group>
                          {universityAppsShorts?.shortlistData?.images?.map(
                            (item, index) => (
                              <Avatar
                                src={item}
                                key={index}
                                className="w-[3.25em] h-[3.25em] aspect-square"
                              />
                            )
                          )}
                        </Avatar.Group>
                      )}
                    </div>
                    <div className="flex flex-col gap-2 text-white w-max ">
                      <div className="font-semibold">
                        {universityAppsShorts?.shortlistData?.count} Students
                      </div>
                      <div
                        className="text-[0.825em] line-clamp-1 text-ellipsis"
                        title={university?.university?.common?.name}
                      >
                        Applied in {university?.university?.common?.name}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Spacer height={30} />
            <div className="px-4">
              <tabs.UniversityTab
                items={tabsArray}
                onChange={(value) => {
                  switch (value) {
                    case "2":
                      navigate(`/universities/${id}`);
                      break;
                    case "3":
                      navigate(`/universities/${id}`);
                      break;
                    case "4":
                      navigate(`/universities/${id}`);
                      break;
                    case "5":
                      navigate(`/universities/${id}`);
                      break;
                    default:
                      navigate(`/universities/${id}`);
                  }
                }}
              />
            </div>
            <Spacer height={30} />
          </>
        )}
        <modal.DefaultModal
          open={isAboutModalOpen}
          onCancel={() => setIsAboutModalOpen(false)}
          closable
        >
          <div className="flex flex-col justify-center items-center p-4 w-[37.5em] gap-5">
            <div className="text-[1.625em] font-bold text-center">
              {university?.university?.common?.name}
            </div>
            <div className="font-medium text-justify text-[1em]">
              {university?.university?.common?.aboutUs}
            </div>
          </div>
        </modal.DefaultModal>
        <modal.DefaultModal
          open={isApplicationModalOpen}
          onCancel={() => setIsApplicationModalOpen(false)}
          closable={false}
        >
          <div className="flex flex-col justify-center items-center p-4 w-[31.25em] gap-5">
            <img src={Images.Unigeneralapplynow} />
            <div className="font-medium text-center text-[1em]">
              You will now be directed to the university application page.
              Please submit your application & upload proof of your
              applicationin the UniVision Applications section.
            </div>
          </div>
        </modal.DefaultModal>
      </div>
    </Modal>
  );
};
export default UniversityInfoModal;
